import classNames from '../../../../../../_virtual/index.mjs';
import React__default from 'react';
import modules_d098bf60 from './AnimatedContainer.module.css.mjs';

const AnimatedContainer = ({ isOpen, children })=>/*#__PURE__*/ React__default.createElement("div", {
        className: classNames(modules_d098bf60.container, {
            [modules_d098bf60.open]: isOpen
        }),
        "aria-live": "polite"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: modules_d098bf60.inner,
        "aria-hidden": !isOpen
    }, children));

export { AnimatedContainer as default };
//# sourceMappingURL=AnimatedContainer.mjs.map
